import _isArray from 'lodash/isArray';

export function createAccessKey(accessPath = []) {
  if (!_isArray(accessPath)) return '';
  return `${accessPath.join('.submenu.')}.enabled`;
}
